export class CreateEventCommand {
  public name: string;
  public description: string;
  public host: string;
  public category: string;
  public startTime: Date;
  public endTime: Date;
  public startTimeText: string;
  public endTimeText: string;
  public timezone: string;
  public frequency: string;
  public image: File;
  public eventTimes = [];
  public eventTimesText = [];
  public address: {
    lat: number;
    lng: number;
    address: string;
    addressComponents?: {
      long_name: string;
      short_name: string;
      types: string[];
    }[];
    placeId?: string;

    address_components: any; // the address input component uses this field name, but event collection uses addressComponents, it will be coverted to addressComponents in CreateEventCompomandHandler.ts
  };
  public venue: string;
  public defaultImage: string;
  public ticketUri: string;
  public isHubCreated: boolean;
  public isFacebookEvent: boolean;
  public hostLink: string;
  public eventLink: string;
  public imageLink: string;
  public organizerEmail: string;
  public isOnlineEvent: boolean;
  public isHybridEvent: boolean;
  public isApproved: boolean;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/hub/event/create.event.command.ts